var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82324 8.4375L7.94824 5V7.75H10.6982V9.125H7.94824V11.875L3.82324 8.4375ZM25.8232 8.4375L21.6982 5V7.75H17.5732V9.125H21.6982V11.875L25.8232 8.4375ZM15.5107 11.875L21.0985 12.8909C22.1977 13.0908 22.9379 14.1296 22.7681 15.2338L21.6982 22.1875H12.7607L10.9147 19.8799C10.3295 19.1485 10.0107 18.2397 10.0107 17.303V15.3125C10.0107 14.5531 10.6264 13.9375 11.3857 13.9375H12.0732V16H12.7607V6.375C12.7607 5.61562 13.3764 5 14.1357 5C14.8951 5 15.5107 5.61562 15.5107 6.375V11.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipe);
export default __webpack_public_path__ + "static/media/swipe.5df33528bddf7035add3b1ff8f751839.svg";
export { ForwardRef as ReactComponent };